import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { NodeBuilder } from '../../../../../../../shared/models';
import { algorithmGroup, Encrypt, EncryptTypes } from './encrypt';
import { MatSelect, MatOptgroup, MatOption as MatOption_1 } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { NgTemplateOutlet, KeyValuePipe } from '@angular/common';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

const NODE_TYPE = 'encrypt';

@Component({
    selector: 'app-encrypt',
    templateUrl: './encrypt.component.html',
    styleUrls: ['./encrypt.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, ClickatellFormValidationComponent, ActiveFormDirective, MatSelect, MatOptgroup, MatOption_1, NgTemplateOutlet, CMSComponent, NextSelectorComponent, KeyValuePipe]
})
export class EncryptComponent extends NodeBuilder implements OnInit {

  readonly algorithmGroup = algorithmGroup;
  encryptForm: UntypedFormGroup;
  algorithmsForm: UntypedFormGroup;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    const forms = Encrypt.toForm(stepData, this.canEdit);
    this.encryptForm = forms.encryptFrom;
    this.algorithmsForm = forms.algorithmsForm;


    if (this.encryptForm.get('yes').value === newStepValue) {
      this.encryptForm.get('yes').setValue('step' + this.getNextStep());
    }
    if (this.encryptForm.get('no').value === newStepValue) {
      this.encryptForm.get('no').setValue('step' + this.getNextStep());
    }
  }

  get getStepData(): {} {
    const encryptFormRawValue = this.encryptForm?.getRawValue();
    const algorithmsFormRawValue = this.algorithmsForm?.getRawValue();
    const nodeData = new Encrypt();
    nodeData.addActionData(encryptFormRawValue, algorithmsFormRawValue);
    return nodeData.nodeData;
  }

  get isNodeValid(): boolean {
    this.encryptForm.markAllAsTouched();
    this.algorithmsForm.markAllAsTouched();
    return this.encryptForm.valid && this.algorithmsForm.valid;
  }

  public algorithmChange(event: MatSelect): void {
    const selected: MatOption = event.selected as MatOption;
    const method = selected.group.label as EncryptTypes;
    const encoding = selected.value;
    this.algorithmsForm = Encrypt.buildAlgorithmsForm({
      method,
      encoding,
      publicKey: '',
      compression: '',
    }, this.canEdit.canEditFlows);
  }

  public addVariable(): void {
    const strings: UntypedFormArray = this.encryptForm.get('strings') as UntypedFormArray;
    strings.push(Encrypt.stringsTemplate('', this.canEdit.canEditFlows));
  }

}
